import { render, staticRenderFns } from "./SelectTaxCodeModel.vue?vue&type=template&id=0164a314&scoped=true"
import script from "./SelectTaxCodeModel.vue?vue&type=script&lang=js"
export * from "./SelectTaxCodeModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0164a314",
  null
  
)

export default component.exports